import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_RADIO_SELECTED_SCHEMA = Object.freeze({
  RADIO_IDENTIFIER: '',
  RADIO_VALUE: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_RADIO_SELECTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_RADIO_SELECTED_SCHEMA);

export class RadioTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.radio_tapped;
  }

  get properties() {
    return this.toJS();
  }

  setValue(value: any): RadioTappedTrackingAction {
    return this.set(KEYS.RADIO_VALUE, value) as RadioTappedTrackingAction;
  }
}
